














import { Component, Vue } from 'vue-property-decorator';
import UserNav from '@/components/user/UserNav.vue';

@Component({
  components: {
    UserNav,
  },
})
export default class UserOverview extends Vue {
}
